import { StyledFooter } from '../StyledComponents';

export default function NotificationFooter() {
    return <StyledFooter>Notifications will be available for 30 days.</StyledFooter>;
}
